import React, { useState, useContext } from 'react';
import AuthContext from '../context/AuthContext';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, error } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await login(email, password);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-content-bg">
      <div className="card w-full max-w-md">
        <div className="flex flex-col items-center mb-6">
          <svg className="h-12 w-12 text-gold" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="M7 16v-4h4v4h-4z"/><path d="M15 16v-8h4v8h-4z"/><path d="M11 16v-6h4v6h-4z"/></svg>
          <h1 className="text-2xl font-bold text-slate-800 mt-4">JJMIS Portal</h1>
          <p className="text-slate-500">A secure Juvenile Justice Management Information System (JJMIS) for tracking case files, offenses, and rehabilitation progress for authorized personnel.</p>
          <p className="text-slate-500">Sign in to your account</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full py-2 px-3 border border-slate-300 rounded-lg shadow-sm bg-slate-50 focus:outline-none focus:ring-2 focus:ring-gold focus:border-gold"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full py-2 px-3 border border-slate-300 rounded-lg shadow-sm bg-slate-50 focus:outline-none focus:ring-2 focus:ring-gold focus:border-gold"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-gold text-white hover:bg-gold-dark font-bold py-3 px-4 rounded-lg shadow-md transition-all duration-200"
          >
            Login
          </button>
        </form>
        {error && <p className="text-red-500 text-center mt-4">{error}</p>}
      </div>
    </div>
  );
}

export default LoginPage;
